export const nameRule = [
  v => !!v || 'Name is required',
  v => (v && v.length <= 50) || 'Name must be less than 50 characters'
]
export const emailRule = [
  v => !!v || 'Email is required',
  v => /.+@.+/.test(v) || 'Email must be valid'
]
export const alphaNumRule = [
  v => /^[a-z0-9A-Z]+$/.test(v) || 'Must contain alpha numberic characters'
]
export const alphaNumCustCategoryRule = [
  v => /^[a-z0-9A-Z &]+$/.test(v) || 'Must contain alpha numberic characters',
  v => (v && v.length <= 30) || 'Name must be 30 characters or less'
]
export const titleRule = [
  v => !!v || 'Title is required',
  v =>
    (v && v.length <= 50) || 'Maximum character count of 50 has been exceeded'
]
export const passwordRule = [
  v => !!v || 'Password is required',
  v => (v && v.length >= 8) || 'At least 8 characters are required',
  v => /(?=.*[A-Z])/.test(v) || 'At least 1 uppercase character is required',
  v => /(?=.*\d)/.test(v) || 'At least 1 number is required',
  v => /([^\w\s])/.test(v) || 'Password requires at least one special character'
]
